<template>
  <div class="leftnav" v-if="applicationType == 7">
    <div class="navConLogo">
      <img src="../../static/images/whiteLogo.png" />
    </div>
    <el-menu :collapse-transition="false" router :unique-opened="false" :default-active="$route.path" :default-openeds="openeds">
      <!-- 渲染侧边栏 -->
      <template v-for="item in menuList">
        <!-- 二级路由渲染 -->
        <el-submenu v-if="item.children" :index="item.num" :key="item.num">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>
              {{ item.name }}
              <span
                :style="{ left: waitCount.productionWaitCount > 9 ? '141px' : '145px' }"
                class="menu-info"
                v-if="item.path == '/homeB/subsidyapplication' && waitCount.productionWaitCount && JDBM.areaCodeString"
                >{{ waitCount.productionWaitCount }}</span
              >
              <span
                :style="{ left: waitCount.productionWaitCount > 9 ? '141px' : '145px' }"
                class="menu-info"
                v-if="item.path == '/homeB/subsidyapplication' && waitCount.productionPublicCount && !JDBM.areaCodeString"
                >{{ waitCount.productionPublicCount }}</span
              >
            </span>
          </template>
          <el-menu-item v-for="childItem in item.children" :key="childItem.path" :router="true" :index="childItem.path">
            {{ childItem.name }}
            <span
              class="menu-info"
              :style="{ left: waitCount.productionWaitCount > 9 ? '99px' : '101px' }"
              v-if="childItem.path == '/subsidyapplication/production' && waitCount.productionWaitCount && JDBM.areaCodeString"
              >{{ waitCount.productionWaitCount }}</span
            >
            <span
              class="menu-info"
              :style="{ left: waitCount.productionWaitCount > 9 ? '99px' : '101px' }"
              v-if="childItem.path == '/subsidyapplication/production' && waitCount.productionPublicCount && !JDBM.areaCodeString"
              >{{ waitCount.productionPublicCount }}</span
            >
          </el-menu-item>
        </el-submenu>
        <!-- 不带子渲染   哪个跳转哪个写路由-->
        <el-menu-item v-else :key="item.path" :router="true" :index="item.path">
          <i :class="isActive(item.path) ? item.icon : item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
  <div class="leftnav" v-else-if="applicationType == 12">
    <div class="navConLogo">
      <img src="../../static/images/whiteLogo.png" />
    </div>
    <el-menu :collapse-transition="false" router :unique-opened="false" :default-active="$route.path">
      <!-- 渲染侧边栏 -->
      <template v-for="item in menuList">
        <!-- 二级路由渲染 -->
        <el-submenu v-if="item.children" :index="item.menuSort" :key="item.menuSort" style="width: 190px">
          <template slot="title">
            <i :class="item.menuIcon"></i>
            <span>
              {{ item.menuName }}
              <span
                :style="{ left: approvalCunt > 9 ? '134px' : '134px' }"
                class="menu-info"
                v-if="item.menuPath == '/loanaidinstitutions/application' && approvalCunt > 0"
                >{{ approvalCunt < 99 ? approvalCunt : '99+' }}</span
              >
            </span>
          </template>
          <el-menu-item v-for="childItem in item.children" :key="childItem.menuPath" :router="true" :index="childItem.menuPath">
            {{ childItem.menuName }}
            <span
              :style="{ left: approvalCunt > 9 ? '110px' : '110px' }"
              class="menu-info"
              v-if="childItem.menuPath == '/loanaidinstitutions/application/pendingreview' && approvalCunt > 0"
              >{{ approvalCunt < 99 ? approvalCunt : '99+' }}</span
            >
          </el-menu-item>
        </el-submenu>
        <!-- 不带子渲染   哪个跳转哪个写路由-->
        <el-menu-item v-else :key="item.menuPath" :router="true" :index="item.menuPath">
          <i :class="isActive(item.menuPath) ? item.menuIcon : item.menuIcon"></i>
          <span slot="title">{{ item.menuName }}</span>
          <span
            :style="{ left: approvalCunt > 99 ? '120px' : '118px' }"
            class="menu-info"
            v-if="item.menuPath == '/loanAdmin/productManagement' && approvalCunt > 0"
            >{{ approvalCunt < 99 ? approvalCunt : '99+' }}</span
          >
        </el-menu-item>
      </template>
    </el-menu>
  </div>
  <div class="leftnav" v-else-if="applicationType == 14">
    <div class="navConLogo">
      <img src="../../static/images/whiteLogo.png" />
    </div>
    <el-menu :collapse-transition="false" router :unique-opened="true" :default-active="$route.path">
      <!-- 渲染侧边栏 -->
      <template v-for="item in menuList">
        <!-- 二级路由渲染 -->
        <el-submenu v-if="item.children" :index="item.menuSort" :key="item.menuSort" style="width: 190px">
          <template slot="title">
            <i :class="item.menuIcon"></i>
            <span>
              {{ item.menuName }}
              <span
                :style="{ left: approvalCunt > 9 ? '134px' : '134px' }"
                class="menu-info"
                v-if="item.menuPath == '/loanaidinstitutions/application' && approvalCunt > 0"
                >{{ approvalCunt < 99 ? approvalCunt : '99+' }}</span
              >
            </span>
          </template>
          <el-menu-item v-for="childItem in item.children" :key="childItem.menuPath" :router="true" :index="childItem.menuPath">
            {{ childItem.menuName }}
            <span
              :style="{ left: approvalCunt > 9 ? '110px' : '110px' }"
              class="menu-info"
              v-if="childItem.menuPath == '/loanaidinstitutions/application/pendingreview' && approvalCunt > 0"
              >{{ approvalCunt < 99 ? approvalCunt : '99+' }}</span
            >
          </el-menu-item>
        </el-submenu>
        <!-- 不带子渲染   哪个跳转哪个写路由-->
        <el-menu-item v-else :key="item.menuPath" :router="true" :index="item.menuPath">
          <i :class="isActive(item.menuPath) ? item.menuIcon : item.menuIcon"></i>
          <span slot="title">{{ item.menuName }}</span>
          <span
            :style="{ left: approvalCunt > 99 ? '120px' : '118px' }"
            class="menu-info"
            v-if="item.menuPath == '/loanAdmin/productManagement' && approvalCunt > 0"
            >{{ approvalCunt < 99 ? approvalCunt : '99+' }}</span
          >
        </el-menu-item>
      </template>
    </el-menu>
  </div>
  <div class="leftnav leftnumber" v-else>
    <div class="navConLogo">
      <img src="../../static/images/whiteLogo.png" />
    </div>
    <div class="navDiv">
      <el-menu :collapse-transition="false" router :unique-opened="true" :default-active="$route.path">
        <!-- 渲染侧边栏 -->
        <template v-for="item in menuList">
          <!-- 二级路由渲染 -->
          <el-submenu v-if="item.children" :index="item.num" :key="item.num">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item v-for="childItem in item.children" :key="childItem.path" :router="true" :index="childItem.path">
              {{ childItem.name }}
            </el-menu-item>
          </el-submenu>
          <!-- 不带子渲染   哪个跳转哪个写路由-->
          <el-menu-item v-else :key="item.path" :router="true" :index="item.path">
            <i :class="isActive(item.path) ? item.icon : item.icon"></i>
            <span slot="title" style="position: relative; overflow: visible"
              >{{ item.name }}
              <span class="menu-info" style="right: -25px; top: -10px" v-if="item.num == '1297' && authNumber > 0">{{
                authNumber
              }}</span></span
            >
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { administrative, getPcAdminWaitCount } from '@/api/cattlesubsidy';
import { useryangfengquanxian } from '@/api/beekeeping';
import { getWebMenuTreeByAppId, getWebMenuTreeByFarmId } from '@/api/system';
import { webMenuTreeByAppId } from '@/api/loanAdmin';
import { getZhyzDynamicMenuSign } from '@/api/login'; // 判断是否显示动态菜单
import { queryProductStatistical, statisticsApplyOrder } from '@/api/loanaidinstitutions';

import { getCalfUserInfo } from '@/api/cattlesubsidy';

import { mapState, mapMutations } from 'vuex';
import { applyTransform } from 'zrender/lib/core/vector';
import { livestockType } from '../utils/config';

// 20250221 种畜禽需求
import { LBUserInfo } from '@/views/breedingcattle/common/index.js';
import { pageLivestock_LB } from '@/api/breedingLivestockApi';
export default {
  name: 'XmdpcLeftnav',
  data() {
    return {
      openeds: ['897'],
      applicationType: 1,
      menuAuthority: [],
      menuList: [
        {
          num: '1',
          menuId: '4',
          path: '/SmartLivestock/homeview',
          name: '首页',
          icon: 'el-icon-house'
        }
      ],
      menuList1: [
        {
          num: '1',
          menuId: '4',
          path: '/SmartLivestock/homeview',
          name: '首页',
          icon: 'el-icon-house'
        },
        {
          num: '2',
          name: '实时监控管理',
          icon: 'el-icon-help',
          children: [
            {
              path: '/monitorManage/padList',
              name: '设备列表',
              icon: ''
            },
            {
              path: '/monitorManage/aiStatistics',
              name: 'Ai算法统计',
              icon: ''
            },
            {
              path: '/monitorManage/xmds',
              name: '小牧丁App下载',
              icon: ''
            }
          ]
        },
        {
          num: '3',
          name: '内容发布管理',
          icon: 'el-icon-monitor',
          children: [
            {
              path: '/contentRelease/policy',
              name: '政策文件',
              icon: ''
            },
            {
              path: '/contentRelease/stockMarket',
              name: '行情指数',
              icon: ''
            },
            {
              path: '/contentRelease/voice',
              name: '语音消息',
              icon: ''
            }
          ]
        },
        {
          num: '4',
          name: '经营主体管理',
          icon: 'el-icon-odometer',
          children: [
            {
              path: '/businessTheme/homeFarm',
              name: '家庭农场',
              icon: ''
            },
            {
              path: '/businessTheme/artel',
              name: '合作社',
              icon: ''
            },
            {
              path: '/businessTheme/farmingEnterprises',
              name: '养殖企业',
              icon: ''
            },
            {
              path: '/businessTheme/Trafficker',
              name: '贩运经纪人',
              icon: ''
            },
            {
              path: '/businessTheme/slaughter',
              name: '屠宰场',
              icon: ''
            },
            {
              path: '/businessTheme/fodder',
              name: '饲料之家',
              icon: ''
            },
            {
              path: '/businessTheme/vaccine',
              name: '疫苗厂家',
              icon: ''
            }
          ]
        },
        {
          num: '5',
          name: '疫病防治管理',
          icon: 'el-icon-coffee-cup',
          children: [
            {
              path: '/material/info',
              name: '物料信息',
              icon: ''
            },
            {
              path: '/material/list',
              name: '出入库记录',
              icon: ''
            },
            //   {
            //   path: '/disease/preventionPersonnel',
            //   name: '防疫人员管理',
            //   icon: ''
            // },
            {
              path: '/disease/vaccineRecords',
              name: '防疫记录',
              icon: ''
            }
          ]
        },
        {
          num: '6',
          name: '屠宰溯源管理',
          icon: 'el-icon-orange',
          children: [
            {
              path: '/homeZ/slaughterCur',
              name: '实施监督',
              icon: ''
            },
            {
              path: '/homeZ/slaughterList',
              name: '屠宰进场记录',
              icon: ''
            }
          ]
        },
        {
          num: '7',
          name: '产业金融服务',
          icon: 'el-icon-c-scale-to-original',
          children: [
            {
              path: '/financialService/moneyToApply',
              name: '资金申请审批',
              icon: ''
            },
            {
              path: '/financialService/livestockInsurance',
              name: '畜只保险服务',
              icon: ''
            },
            {
              path: '/financialService/dataStatistics',
              name: '数据统计',
              icon: ''
            }
          ]
        },
        {
          num: '8',
          name: '技术指导服务',
          icon: 'el-icon-takeaway-box',
          children: [
            {
              path: '/technicalGuidance/liveTraining',
              name: '直播培训',
              icon: ''
            },
            {
              path: '/technicalGuidance/coursewareVideo',
              name: '课件视频',
              icon: ''
            },
            {
              path: '/technicalGuidance/serviceInformation',
              name: '服务信息设置',
              icon: ''
            }
          ]
        },
        // {
        //   num: '9',
        //   name: '大数据中心',
        //   icon: 'el-icon-edit-outline',
        //   children: [{
        //     path: '/datas/bigData',
        //     name: '可视化大数据',
        //     icon: ''
        //   },
        //     {
        //       path: '/datas/vr',
        //       name: 'VR数字乡村',
        //       icon: ''
        //     }
        //   ]
        // },
        // {
        //   num: '10',
        //   name: '物料管理',
        //   icon: 'el-icon-date',
        //   children: [
        //     // {
        //     //   path: '/material/out',
        //     //   name: '出库记录',
        //     //   icon: ''
        //     // }
        //   ]
        // },
        {
          num: '9',
          name: '数据统计',
          icon: 'el-icon-money',
          children: [
            {
              path: '/statistics/showData',
              name: '大数据展示',
              icon: ''
            }
          ]
        },
        // {
        //   num: '11',
        //   name: '人员管理',
        //   icon: 'el-icon-money',
        //   children: [
        //     {
        //       path: '/peopleManage/organizational',
        //       name: '组织机构',
        //       icon: ''
        //     },
        //     {
        //       path: '/peopleManage/personnel',
        //       name: '人员信息',
        //       icon: ''
        //     },

        //   ]
        // },
        {
          num: '10',
          name: '系统设置',
          icon: 'el-icon-data-line',
          children: [
            {
              path: '/peopleManage/organizational',
              name: '组织机构',
              icon: ''
            },
            {
              path: '/peopleManage/personnel',
              name: '人员信息',
              icon: ''
            }
            //   {
            //   path: '/system/systemSetting',
            //   name: '系统设置',
            //   icon: ''
            // }
          ]
        }
      ],
      menuList2: [
        {
          num: '1',
          menuId: '4',
          path: '/SmartLivestock/homeview',
          name: '首页',
          icon: 'el-icon-house'
        },
        {
          num: '2',
          name: '实时监控管理',
          icon: 'el-icon-help',
          children: [
            {
              path: '/monitorManage/padList',
              name: '设备列表',
              icon: ''
            },
            {
              path: '/monitorManage/aiStatistics',
              name: 'Ai算法统计',
              icon: ''
            },
            {
              path: '/monitorManage/xmds',
              name: '小牧丁App下载',
              icon: ''
            }
          ]
        },
        {
          num: '3',
          name: '内容发布管理',
          icon: 'el-icon-monitor',
          children: [
            {
              path: '/contentRelease/policy',
              name: '政策文件',
              icon: ''
            },
            {
              path: '/contentRelease/stockMarket',
              name: '行情指数',
              icon: ''
            },
            {
              path: '/contentRelease/voice',
              name: '语音消息',
              icon: ''
            }
          ]
        },
        {
          num: '4',
          name: '经营主体管理',
          icon: 'el-icon-odometer',
          children: [
            {
              path: '/businessTheme/homeFarm',
              name: '家庭农场',
              icon: ''
            },
            {
              path: '/businessTheme/artel',
              name: '合作社',
              icon: ''
            },
            {
              path: '/businessTheme/farmingEnterprises',
              name: '养殖企业',
              icon: ''
            },
            {
              path: '/businessTheme/Trafficker',
              name: '贩运经纪人',
              icon: ''
            },
            {
              path: '/businessTheme/slaughter',
              name: '屠宰场',
              icon: ''
            },
            {
              path: '/businessTheme/fodder',
              name: '饲料之家',
              icon: ''
            },
            {
              path: '/businessTheme/vaccine',
              name: '疫苗厂家',
              icon: ''
            }
          ]
        },
        {
          num: '5',
          name: '疫病防治管理',
          icon: 'el-icon-coffee-cup',
          children: [
            {
              path: '/material/info',
              name: '物料信息',
              icon: ''
            },
            {
              path: '/material/list',
              name: '出入库记录',
              icon: ''
            },
            //   {
            //   path: '/disease/preventionPersonnel',
            //   name: '防疫人员管理',
            //   icon: ''
            // },
            {
              path: '/disease/vaccineRecords',
              name: '防疫记录',
              icon: ''
            }
          ]
        },
        {
          num: '6',
          name: '屠宰溯源管理',
          icon: 'el-icon-orange',
          children: [
            {
              path: '/homeZ/slaughterCur',
              name: '实施监督',
              icon: ''
            },
            {
              path: '/homeZ/slaughterList',
              name: '屠宰进场记录',
              icon: ''
            }
          ]
        },
        {
          num: '7',
          name: '产业金融服务',
          icon: 'el-icon-c-scale-to-original',
          children: [
            {
              path: '/financialService/moneyToApply',
              name: '资金申请审批',
              icon: ''
            },
            {
              path: '/financialService/livestockInsurance',
              name: '畜只保险服务',
              icon: ''
            },
            {
              path: '/financialService/dataStatistics',
              name: '数据统计',
              icon: ''
            }
          ]
        },
        {
          num: '8',
          name: '技术指导服务',
          icon: 'el-icon-takeaway-box',
          children: [
            {
              path: '/technicalGuidance/liveTraining',
              name: '直播培训',
              icon: ''
            },
            {
              path: '/technicalGuidance/coursewareVideo',
              name: '课件视频',
              icon: ''
            },
            {
              path: '/technicalGuidance/serviceInformation',
              name: '服务信息设置',
              icon: ''
            }
          ]
        },
        // {
        //   num: '9',
        //   name: '大数据中心',
        //   icon: 'el-icon-edit-outline',
        //   children: [{
        //     path: '/datas/bigData',
        //     name: '可视化大数据',
        //     icon: ''
        //   },
        //     {
        //       path: '/datas/vr',
        //       name: 'VR数字乡村',
        //       icon: ''
        //     }
        //   ]
        // },
        // {
        //   num: '10',
        //   name: '物料管理',
        //   icon: 'el-icon-date',
        //   children: [
        //     // {
        //     //   path: '/material/out',
        //     //   name: '出库记录',
        //     //   icon: ''
        //     // }
        //   ]
        // },
        {
          num: '9',
          name: '数据统计',
          icon: 'el-icon-money',
          children: [
            {
              path: '/statistics/showData',
              name: '大数据展示',
              icon: ''
            }
          ]
        },
        // {
        //   num: '11',
        //   name: '人员管理',
        //   icon: 'el-icon-money',
        //   children: [
        //     {
        //       path: '/peopleManage/organizational',
        //       name: '组织机构',
        //       icon: ''
        //     },
        //     {
        //       path: '/peopleManage/personnel',
        //       name: '人员信息',
        //       icon: ''
        //     },
        //   ]
        // },
        {
          num: '10',
          name: '系统设置',
          icon: 'el-icon-data-line',
          children: [
            {
              path: '/peopleManage/organizational',
              name: '组织机构',
              icon: ''
            },
            {
              path: '/peopleManage/personnel',
              name: '人员信息',
              icon: ''
            }
            //   {
            //   path: '/system/systemSetting',
            //   name: '系统设置',
            //   icon: ''
            // }
          ]
        }
      ],
      userobj: {},
      info: null,
      loans: null,
      info2: [4, 8, 14, 16, 17, 56, 58],
      obj: {},
      quanxianlist: [],
      JDBM: {},
      waitCount: {
        outWaitCount: '',
        productionWaitCount: '',
        productionPublicCount: ''
      },
      // 统计 - 种畜认证申请
      authNumber: 0
    };
  },
  created() {
    this.userobj = JSON.parse(localStorage.getItem('itemInfo'));
    this.info = JSON.parse(localStorage.getItem('info'));
    this.loans = JSON.parse(localStorage.getItem('loans'));
    this.applicationType = localStorage.getItem('applicationType');
    // this.activeIndex = this.$route.path.substring(1, this.$route.path.length);
  },
  mounted() {
    if (this.applicationType == 2) {
      this.getuserO();
    }
    if (this.applicationType == 0) {
      this.menuList = [
        // 大屏可视化
        {
          num: '1',
          path: '/products/visual',
          name: '大数据展示',
          icon: 'el-icon-monitor'
        },
        {
          num: '2',
          path: '/products/qiyeenterprisemanagement',
          name: '企业管理',
          icon: 'el-icon-office-building'
        },
        {
          num: '3',
          path: '/products/enterprisemanagement',
          name: '产品管理',
          icon: 'el-icon-connection'
        },
        {
          num: '4',
          path: '/products/xuchandeviceview',
          name: '实时监控',
          icon: 'el-icon-video-camera'
        }
      ];
    }
    if (this.applicationType == 1) {
      getZhyzDynamicMenuSign(localStorage.getItem('farmIdear')).then(res => {
        if (res.data.code == 0) {
          // res.data.data.farmCount = 0; // 饲喂车标记
          if (res.data.data.farmCount > 0) {
            // 大于0动态菜单
            this.getuserzhyz();
          } else {
            // 静态菜单;
            if (res.data.data.farmCount == 0) {
              this.menuList = [
                {
                  num: '1',
                  name: '大数据管理',
                  icon: 'el-icon-coin',
                  children: [
                    {
                      path: '/homeZ/datas',
                      name: '大数据展示',
                      icon: ''
                    },
                    {
                      path: '/homeZ/datasCustom',
                      name: '大数据展示',
                      icon: ''
                    }
                  ]
                },
                {
                  num: '2',
                  name: '牧场设备管理',
                  icon: 'el-icon-video-camera',
                  children: [
                    {
                      path: '/homeZ/pdaList',
                      name: '实时监控管理',
                      icon: ''
                    }
                  ]
                },
                // xu20240110
                {
                  num: '3',
                  name: '智能设备',
                  icon: 'el-icon-cpu',
                  children: [
                    {
                      path: '/homeZ/smartDevices',
                      name: '设备列表',
                      icon: ''
                    },
                    {
                      path: '/homeZ/perceivedState',
                      name: '感知状态一张图',
                      icon: ''
                    },
                    {
                      path: '/homeZ/regulatorySystem',
                      name: '精准调控系统',
                      icon: ''
                    }
                  ]
                },
                {
                  num: '4',
                  name: '畜只管理',
                  icon: 'el-icon-help',
                  children: [
                    {
                      path: '/homeZ/intheBar',
                      name: '在栏畜只',
                      icon: ''
                    },
                    {
                      path: '/homeZ/immune',
                      name: '免疫记录',
                      icon: ''
                    },
                    {
                      path: '/homeZ/medicine',
                      name: '用药记录',
                      icon: ''
                    },
                    {
                      path: '/homeZ/breed',
                      name: '繁育记录',
                      icon: ''
                    },
                    {
                      path: '/homeZ/such',
                      name: '出栏/淘汰',
                      icon: ''
                    }
                  ]
                },
                {
                  num: '5',
                  name: '饲喂管理',
                  icon: 'el-icon-money',
                  children: [
                    {
                      path: '/homeZ/feedingVehicles',
                      name: '饲喂车辆',
                      icon: ''
                    },
                    {
                      path: '/homeZ/feedingRecords',
                      name: '饲喂记录',
                      icon: ''
                    },
                    {
                      path: '/homeZ/tmr',
                      name: 'TMR中央厨房',
                      icon: ''
                    },
                    {
                      path: '/homeZ/mixture',
                      name: '混料/出料记录',
                      icon: ''
                    }
                  ]
                },
                {
                  num: '6',
                  name: '物料管理',
                  icon: 'el-icon-money',
                  children: [
                    {
                      path: '/homeZ/info',
                      name: '物料信息',
                      icon: ''
                    },
                    {
                      path: '/homeZ/list',
                      name: '入库记录',
                      icon: ''
                    },
                    {
                      path: '/homeZ/out',
                      name: '使用记录',
                      icon: ''
                    }
                  ]
                },
                {
                  num: '9',
                  name: '圈舍管理',
                  icon: 'el-icon-guide',
                  children: [
                    {
                      path: '/homeZ/distinguish',
                      name: '区管理',
                      icon: ''
                    },
                    {
                      path: '/homeZ/shedManagement',
                      name: '棚管理',
                      icon: ''
                    },
                    {
                      path: '/homeZ/columnManagement',
                      name: '栏管理',
                      icon: ''
                    }
                  ]
                },
                {
                  num: '7',
                  name: '系统设置',
                  icon: 'el-icon-setting',
                  children: [
                    {
                      path: '/system/systemSetting',
                      name: '基础信息',
                      icon: ''
                    },
                    {
                      path: '/homeZ/user',
                      name: '人员管理',
                      icon: ''
                    },
                    {
                      path: '/homeZ/userGroup',
                      name: '角色管理',
                      icon: ''
                    },
                    {
                      path: '/homeZ/userCaidan',
                      name: '菜单管理',
                      icon: ''
                    },
                    {
                      path: '/homeZ/operationLog',
                      name: '操作日志',
                      icon: ''
                    },
                    {
                      path: '/homeZ/loginLog',
                      name: '登录日志',
                      icon: ''
                    }
                  ]
                }
              ];
              if (this.userobj.showCustom == 1) {
                this.menuList[0].children.splice(0, 1);
                this.$router.push({
                  path: '/homeZ/datasCustom'
                });
              } else {
                this.menuList[0].children.splice(1, 1);
              }
            } else {
              this.menuList = [
                {
                  num: '1',
                  name: '首页',
                  icon: 'el-icon-coin',
                  path: '/homeZ/homear'
                }
              ];
              this.$router.push({
                path: '/homeZ/homear'
              });
            }
          }
        }
      });
    }
    if (this.applicationType == 5) {
      this.menuList = [
        {
          num: '1',
          path: '/homeT/passageManage',
          name: '通道实时管理',
          icon: 'passageManage-icon'
        },
        {
          num: '2',
          path: '/homeT/orderManage',
          name: '进场订单管理',
          icon: 'orderManage-icon'
        }
      ];
    }
    if (this.applicationType == 11) {
      this.menuList = [
        {
          num: '1',
          path: '/homeF/index',
          name: '首页',
          icon: 'passageManage-icon'
        },
        {
          num: '2',
          path: '/homeF/visualLargeScreen',
          name: '数据可视化',
          icon: 'orderManage-icon'
        }
      ];
    }
    if (this.applicationType == 100) {
      this.menuList = [
        {
          num: '1',
          path: '/homeB/index',
          name: '首页',
          icon: 'el-icon-house'
        },
        {
          num: '2',
          path: '/homeB/Equipmentapplication',
          name: '设备申请',
          icon: 'el-icon-monitor'
        }
      ];
    }
    if (this.applicationType == 8) {
      this.zhihuiyangfeng();
    }
    if (this.applicationType == 7) {
      // 旧的
      // this.userobj = JSON.parse(localStorage.getItem('deptList')).personOrg;
      // 新的 20241011
      this.userobj = {};
      const multiRoleAll_JDBM = JSON.parse(localStorage.getItem('multiRoleAll_JDBM'));
      this.userobj.applicationId = multiRoleAll_JDBM ? multiRoleAll_JDBM.applicationId : '';
      this.userobj.userName = multiRoleAll_JDBM ? multiRoleAll_JDBM.userName : '';
      const deptUserRole_JDBM = JSON.parse(localStorage.getItem('deptUserRole_JDBM'));
      this.userobj.roleCode = deptUserRole_JDBM ? deptUserRole_JDBM.roleCode : '';
      this.userobj.deptId = deptUserRole_JDBM ? deptUserRole_JDBM.deptId : '';
      this.userobj.areaCode = deptUserRole_JDBM ? deptUserRole_JDBM.areaCode : '';
      this.userobj.manageAreaCode = deptUserRole_JDBM ? deptUserRole_JDBM.manageAreaCode : '';
      this.userobj.justLook = deptUserRole_JDBM ? deptUserRole_JDBM.justLook : '';
      const userApplication_JDBM = JSON.parse(localStorage.getItem('userApplication_JDBM'));
      this.userobj.livestockType = userApplication_JDBM ? userApplication_JDBM.livestockType : '';
      this.userobj.deptName = userApplication_JDBM ? userApplication_JDBM.deptName : '';
      getWebMenuTreeByAppId({
        applicationId: this.userobj.applicationId,
        roleCode: this.userobj.roleCode,
        menuSort: 'menuSort'
        // menuType: '0'
      }).then(res => {
        let menuItems = res.data.data[0].menuItems;

        let menuList = [];
        menuItems.forEach(item => {
          if (item.children) {
            item.children.forEach(val => {
              val.path = val.menuPath;
              val.name = val.menuName;
              val.icon = val.menuIcon;
            });
            menuList.push({
              num: item.menuId,
              path: item.menuPath,
              name: item.menuName,
              icon: item.menuIcon,
              children: item.children
            });
          } else {
            menuList.push({
              num: item.menuId,
              path: item.menuPath,
              name: item.menuName,
              icon: item.menuIcon
            });
          }
        });
        this.JDBM.deptId = this.userobj.deptId;
        this.JDBM.id = this.userobj.applicationId;

        // 旧的
        // let deptList = JSON.parse(localStorage.getItem('deptList'));
        // let roleCode = deptList.roleCode;
        // if (roleCode.search('JDBM_MANAGER') > -1) {
        //   deptList.roleCode = 'JDBM_MANAGER';
        //   deptList.realRoleCode = 'JDBM_MANAGER';
        // }
        // this.JDBM.livestockType = deptList.personOrg.livestockType;
        this.JDBM.livestockType = this.userobj.livestockType;
        // this.JDBM.userName = deptList.personOrg.userName;
        this.JDBM.userName = this.userobj.userName;
        // this.JDBM.deptName = deptList.personOrg.deptName;
        this.JDBM.deptName = this.userobj.deptName;
        // this.JDBM.areaCodeString = deptList.personOrg.areaCode; // 角色所属id
        this.JDBM.areaCodeString = this.userobj.areaCode;
        // this.JDBM.manageAreaCode = deptList.personOrg.manageAreaCode;
        this.JDBM.manageAreaCode = this.userobj.manageAreaCode;
        // this.JDBM.roleCode = deptList.roleCode;
        this.JDBM.roleCode = this.userobj.roleCode;
        // if (deptList.justLook) {
        //   this.JDBM.justLook = deptList.justLook;
        //   this.JDBM.roleCode = deptList.roleCode;
        // }
        if (this.userobj.justLook) {
          this.JDBM.justLook = this.userobj.justLook;
          this.JDBM.roleCode = this.userobj.roleCode;
        }
        /* 见犊补母 - 是否超级管理员 */
        // if (deptList.personOrg.areaCode) {
        //   menuList.splice(1, 1);
        // }
        if (this.userobj.areaCode) {
          menuList.splice(1, 1);
        }
        if (this.JDBM.deptId == '810585' || this.JDBM.deptId == '810648') {
          // 清涧项目新增
          let index = 6;
          let item = {
            icon: 'el-icon-document-copy',
            name: '内容发布',
            num: '895',
            path: '/homeB/policy'
          };
          menuList.splice(index, 0, item);

          menuList[7] = {
            icon: 'el-icon-monitor',
            name: '防疫管理',
            num: '5555',
            path: '/homeB/screenEpidemic',
            children: [
              {
                menuId: '1325',
                menuName: '防疫大屏',
                menuPath: '/homeB/screenEpidemic',
                name: '防疫大屏',
                path: '/homeB/screenEpidemic'
              },
              {
                menuId: '1326',
                menuName: '防疫记录',
                menuPath: '/homeB/compulsoryimmunity',
                name: '防疫记录',
                path: '/homeB/compulsoryimmunity'
              },
              {
                menuId: '1327',
                menuName: '物料信息',
                menuPath: '/homeB/materialLnfo',
                name: '物料信息',
                path: '/homeB/materialLnfo'
              },
              {
                menuId: '1328',
                menuName: '出入库记录',
                menuPath: '/homeB/materialList',
                name: '出入库记录',
                path: '/homeB/materialList'
              }
            ]
          };
        }

        this.menuList = menuList;
        /* 见犊补母 - 大屏 */
        // const personOrg = deptList.personOrg;
        // this.JDBM.personOrg = {
        //   applicationId: personOrg.applicationId,
        //   manageAreaCode: personOrg.manageAreaCode,
        //   livestockType: personOrg.livestockType,
        //   deptId: personOrg.deptId
        // };
        this.JDBM.personOrg = {
          applicationId: this.userobj.applicationId,
          manageAreaCode: this.userobj.manageAreaCode,
          livestockType: this.userobj.livestockType,
          deptId: this.userobj.deptId
        };
        administrative({
          deptId: this.JDBM.deptId,
          livestockType: this.JDBM.livestockType
        }).then(res => {
          this.JDBM.areaCode = res.data.data; // 开通区域对应国标ID
          localStorage.setItem('JDBM', JSON.stringify(this.JDBM));
        });
        this.getPcAdminWaitCount();
        setInterval(() => {
          this.getPcAdminWaitCount();
        }, 1000 * 60);
      });
      // this.menuList = [
      //   {
      //     num: "1",
      //     path: "/homeB/index",
      //     name: "首页",
      //     icon: "el-icon-house"
      //   },
      //   {
      //     num: "2",
      //     path: "/homeB/deviceview",
      //     name: "设备查看",
      //     icon: "el-icon-video-camera"
      //   },
      //   {
      //     num: "3",
      //     path: "/homeB/livestockmanagement",
      //     name: "畜只管理",
      //     icon: "el-icon-orange"
      //   },
      //   {
      //     num: "4",
      //     path: "/homeB/Industrial",
      //     name: "产业主体管理",
      //     icon: "el-icon-monitor"
      //   },
      //   {
      //     num: "5",
      //     path: "/homeB/subsidyapplication",
      //     name: "补贴申请管理",
      //     icon: "el-icon-odometer"
      //   },
      //   {
      //     num: "6",
      //     path: "/homeB/compulsoryimmunity",
      //     name: "防疫管理",
      //     icon: "el-icon-coffee-cup"
      //   },
      //    {
      //     num: "7",
      //     path: "/homeB/Informationofficer",
      //     name: "信息员管理",
      //     icon: "el-icon-data-line"
      //   }
      //   // {
      //   //   num: "6",
      //   //   name: "系统设置",
      //   //   icon: "el-icon-data-line",
      //   //   children: [
      //   //     {
      //   //       path: "/homeB/Informationofficer",
      //   //       name: "信息员管理",
      //   //       icon: ""
      //   //     }
      //   //   ]
      //   // }
      // ];
    }
    if (this.applicationType == 10) {
      this.getzizhouuser();
    }
    if (this.applicationType == 12) {
      if (this.loans.clientId === '30000') {
        this.menuList = [];
        webMenuTreeByAppId({
          roleCode: this.loans.roleCode,
          clientId: this.loans.clientId,
          menuType: 0
        })
          .then(res => {
            this.menuList = res.data.data.menuItemsTree;
          })
          .catch(err => {
            this.loading = false;
          });
        webMenuTreeByAppId({
          roleCode: this.loans.roleCode,
          clientId: this.loans.clientId,
          menuType: 1
        })
          .then(res => {
            this.menuAuthority = res.data.data.menuPermissions;
            localStorage.setItem('menuAuthority', JSON.stringify(this.menuAuthority));
            this.queryProductStatistical();
          })
          .catch(err => {
            this.loading = false;
          });
      }
      if (this.loans.clientId === '20000') {
        this.menuList = [];
        webMenuTreeByAppId({
          roleCode: this.loans.roleCode,
          clientId: this.loans.clientId,
          menuType: 0
        })
          .then(res => {
            this.menuList = res.data.data.menuItemsTree;
          })
          .catch(err => {
            this.loading = false;
          });
        webMenuTreeByAppId({
          roleCode: this.loans.roleCode,
          clientId: this.loans.clientId,
          menuType: 1
        })
          .then(res => {
            this.menuAuthority = res.data.data.menuPermissions;
            localStorage.setItem('menuAuthority', JSON.stringify(this.menuAuthority));
            this.statisticsApplyOrder();
          })
          .catch(err => {
            this.loading = false;
          });
      }
    }
    if (this.applicationType == 14) {
      if (JSON.parse(localStorage.getItem('menuList'))) {
        this.menuList = JSON.parse(localStorage.getItem('menuList'));
      } else {
        getWebMenuTreeByAppId({
          applicationId: this.userobj.applicationId,
          roleCode: this.userobj.roleCode,
          menuSort: 'menuSort',
          menuType: '0'
        }).then(res => {
          localStorage.setItem('menuAuthority', JSON.stringify(res.data.data[0].rolePermissionsList));
          this.menuList = res.data.data[0].menuItems;
        });
      }
    }
    // 种畜禽
    if (this.applicationType == 13) {
      const _UserInformation_LB = JSON.parse(localStorage.getItem('UserInformation_LB'));
      getWebMenuTreeByAppId({
        applicationId: _UserInformation_LB.applicationId,
        roleCode:
          _UserInformation_LB.userAppInfo && _UserInformation_LB.userAppInfo.length > 0 ? _UserInformation_LB.userAppInfo[0].roleCode : '',
        menuSort: 'menuSort',
        menuType: 0
      }).then(res => {
        // localStorage.setItem('menuAuthority', JSON.stringify(res.data.data[0].rolePermissionsList));
        // this.menuList = res.data.data[0].menuItems;
        const { code, data, msg } = res.data;
        if (Number(code) === 0) {
          const _menuItems = data[0].menuItems || [];
          let menuList = [];
          _menuItems.forEach(item => {
            if (item.children) {
              item.children.forEach(val => {
                val.path = val.menuPath;
                val.name = val.menuName;
                val.icon = val.menuIcon;
              });
              menuList.push({
                num: item.menuId,
                path: item.menuPath,
                name: item.menuName,
                icon: item.menuIcon,
                children: item.children
              });
            } else {
              menuList.push({
                num: item.menuId,
                path: item.menuPath,
                name: item.menuName,
                icon: item.menuIcon
              });
            }
          });
          this.menuList = menuList;
        }
      });

      // 20250221 增加种畜认证申请（待审核总计）
      this.requestZationNumber();
    }
  },
  computed: {
    ...mapState(['approvalCunt', 'currentLivestock'])
  },
  methods: {
    ...mapMutations(['changeCunt']),
    // 获取种畜认证申请统计
    requestZationNumber() {
      const _parmas = {
        current: 1,
        size: 20,
        livestockType: this.currentLivestock || '1',
        auditStatus: '0',
        roleCode: LBUserInfo() ? LBUserInfo().roleCode : '',
        // 区域
        areaId: LBUserInfo() ? LBUserInfo().areaCode || '' : '',
        areaLevel: LBUserInfo() ? LBUserInfo().roleLevel || '' : '',
        ascOrDesc: 'desc' // 正序(asc) 倒序(desc)
      };
      pageLivestock_LB(_parmas).then(res => {
        const { code, data, msg } = res.data;
        if (Number(code) === 0) {
          this.authNumber = data.total || 0;
        }
      });
    },
    zhihuiyangfeng() {
      useryangfengquanxian({}).then(res => {
        var type = res.data.data;
        if (type) {
          this.menuList = [
            {
              num: '1',
              path: '/wasp/index',
              name: '首页',
              icon: 'el-icon-house'
            },
            {
              num: '5',
              path: '/wasp/deviceview',
              name: '监控管理',
              icon: 'el-icon-video-camera'
            },
            {
              num: '2',
              path: '/wasp/beefactory',
              name: '蜂场管理',
              icon: 'el-icon-orange'
            },
            {
              num: '3',
              path: '/wasp/device',
              name: '蜂箱管理',
              icon: 'el-icon-help'
            },

            {
              num: '4',
              path: '/wasp/largescreen',
              name: '大数据展示',
              icon: 'el-icon-monitor'
            }
          ];
        } else {
          this.menuList = [
            {
              num: '1',
              path: '/wasp/index',
              name: '首页',
              icon: 'el-icon-house'
            },
            {
              num: '5',
              path: '/wasp/deviceview',
              name: '监控管理',
              icon: 'el-icon-video-camera'
            },
            {
              num: '2',
              path: '/wasp/beefactory',
              name: '蜂场管理',
              icon: 'el-icon-orange'
            },
            {
              num: '3',
              path: '/wasp/device',
              name: '蜂箱管理',
              icon: 'el-icon-help'
            },

            {
              num: '4',
              path: '/wasp/largescreen',
              name: '大数据展示',
              icon: 'el-icon-monitor'
            }
          ];
        }
      });
    },
    // 见犊补母 生产上报菜单左侧值
    getPcAdminWaitCount() {
      getPcAdminWaitCount({
        deptId: this.JDBM.deptId,
        livestockType: this.JDBM.livestockType,
        roleCode: this.JDBM.roleCode,
        areaCode: this.JDBM.areaCodeString
      }).then(res => {
        if (res.data.code == 0) {
          if (res.data.data.productionWaitCount * 1 > 99) {
            res.data.data.productionWaitCount = 99 + '+';
          }
          if (res.data.data.productionPublicCount * 1 > 99) {
            res.data.data.productionPublicCount = 99 + '+';
          }
          this.waitCount = res.data.data;
        }
      });
    },
    // 金融助贷 产品管理菜单左侧值
    queryProductStatistical() {
      queryProductStatistical({
        institutionId: this.loans.institutionId,
        areaCode: this.loans.areaCode,
        roleId: this.loans.roleId,
        clientId: this.loans.clientId,
        areaLevel: this.loans.areaLevel
      }).then(res => {
        this.changeCunt(res.data.data[0].count * 1);
      });
    },
    // 金融助贷 机构端申请数据统计
    statisticsApplyOrder() {
      statisticsApplyOrder({
        institutionId: this.loans.institutionId,
        clientId: this.loans.clientId,
        roleId: this.loans.roleId,
        userId: this.info.userId,
        areaCode: this.loans.areaCode,
        areaLevel: this.loans.areaLevel
      }).then(res => {
        this.changeCunt(res.data.data.orderApplyCount * 1 + res.data.data.institutionApplyCount * 1);
      });
    },

    isActive(path) {
      return this.$route.path === path;
    },
    getuserO() {
      getWebMenuTreeByAppId({
        applicationId: this.userobj.applicationId,
        roleCode: this.userobj.roleCode
      }).then(res => {
        let menuItems = res.data.data[0].menuItems;

        this.getData(menuItems);
        localStorage.setItem('permissiontable', JSON.stringify(this.obj));
        localStorage.setItem('button_list', JSON.stringify(res.data.data[0].rolePermissions));

        this.info.rolePermissions = res.data.data[0].rolePermissions;
        localStorage.setItem('info', JSON.stringify(this.info));

        if (this.info.provincialAndMunicipalLevel == '4') {
          menuItems.forEach((item, i) => {
            if (item.menuPermission == 'zhxm_system_settings') {
              if (item.children) {
                item.children.forEach((val, j) => {
                  if (val.menuPermission == 'zhxm_organizational_management') {
                    item.children.splice(j, 1);
                  }
                });
              }
            }
          });
          menuItems.forEach((item, i) => {
            if (item.menuPermission == 'zhxm_big_data_center') {
              menuItems.splice(i, 1);
            }
          });
          menuItems.forEach((item, i) => {
            if (item.menuPermission == 'zhxm_traceability_management_for_slaughter') {
              menuItems.splice(i, 1);
            }
          });
        }

        let menuList = [];
        menuItems.forEach(item => {
          if (item.children) {
            item.children.forEach(val => {
              val.path = val.menuPath;
              val.name = val.menuName;
              val.icon = val.menuIcon;
            });
            menuList.push({
              num: item.menuId,
              path: item.menuPath,
              name: item.menuName,
              icon: item.menuIcon,
              children: item.children
            });
          } else {
            menuList.push({
              num: item.menuId,
              path: item.menuPath,
              name: item.menuName,
              icon: item.menuIcon
            });
          }
        });
        this.menuList = menuList;
      });
    },
    getuserzhyz() {
      getWebMenuTreeByFarmId({
        farmId: localStorage.getItem('farmIdear'),
        roleCode: localStorage.getItem('roleCode'),
        roleId: localStorage.getItem('roleId'),
        menuSort: 'menuSort'
      }).then(res => {
        let menuItems = res.data.data[0].menuItems;
        this.getData(menuItems);
        let menuList = [];
        menuItems.forEach(item => {
          if (item.children) {
            item.children.forEach(val => {
              val.path = val.menuPath;
              val.name = val.menuName;
              val.icon = val.menuIcon;
            });
            menuList.push({
              num: item.menuId,
              path: item.menuPath,
              name: item.menuName,
              icon: item.menuIcon,
              children: item.children
            });
          } else {
            menuList.push({
              num: item.menuId,
              path: item.menuPath,
              name: item.menuName,
              icon: item.menuIcon
            });
          }
        });
        this.menuList = menuList;
        if (this.userobj.showCustom == 1) {
          this.menuList[0].children.splice(0, 1);
          this.$router.push({
            path: '/homeZ/datasCustom'
          });
        } else {
          this.menuList[0].children.splice(1, 1);
        }
        if (this.$route.query.login) {
          this.$router.push({
            path: this.menuList[0].children[0].path
          });
        }
      });
    },
    getzizhouuser() {
      this.getuserOzizhou(JSON.parse(localStorage.getItem('zizhouuserInfo')));
    },
    getuserOzizhou(item) {
      getWebMenuTreeByAppId({
        applicationId: this.userobj.applicationId,
        roleCode: item.xmptRoleCode,
        deptId: item.applicationDeptId,
        menuSort: 'menuSort',
        menuType: '0'
      }).then(res => {
        let menuItems = res.data.data[0].menuItems;
        localStorage.setItem('rolePermissionsList', JSON.stringify(res.data.data[0].rolePermissionsList));
        let menuList = [];
        menuItems.forEach(item => {
          if (item.children) {
            item.children.forEach(val => {
              val.path = val.menuPath;
              val.name = val.menuName;
              val.icon = val.menuIcon;
            });
            menuList.push({
              num: item.menuId,
              path: item.menuPath,
              name: item.menuName,
              icon: item.menuIcon,
              children: item.children
            });
          } else {
            menuList.push({
              num: item.menuId,
              path: item.menuPath,
              name: item.menuName,
              icon: item.menuIcon
            });
          }
        });
        this.menuList = menuList;
        // this.menuList.push({
        //   icon: 'el-icon-document-copy',
        //   name: '地图',
        //   num: '111111',
        //   path: '/map'
        // });
        if (this.info.userAccount == '13509129544') {
          // 单独特殊处理
          this.menuList = [
            {
              applicationId: 16,
              applicationName: '畜牧平台',
              applicationNo: 'XMPT20230915',
              applicationType: '10',
              children: [],
              deptId: 42222,
              deptName: null,
              icon: 'el-icon-takeaway-box',
              num: '1156',
              name: '大数据中心',
              path: '/zzry/showDataLevel',
              menuPermission: null,
              menuSort: '2',
              menuType: '0',
              parentId: '0',
              roleCode: 'CITY_ADMINISTRATOR',
              roleId: 32,
              roleName: '市管理员',
              userId: null,
              userName: null,
              userPhone: null,
              visible: null
            }
          ];
          this.$router.push({
            path: '/zzry/showDataLevel'
          });
        }
      });
    },
    getData(arr) {
      arr.forEach(item => {
        this.obj[item.menuPermission] = item.menuId;
        if (item.children) {
          this.getData(item.children);
        }
      });
    },
    getArr(arr) {
      if (this.info.length > 0) {
        if (typeof this.info[0] != 'string') {
          this.info.forEach(val => {
            val = val.toString();
          });
        }
      }

      arr.forEach((item, index) => {
        if (this.info.indexOf(item.menuId) === -1) {
          arr.splice(index, 1);
          this.getArr(arr);
        } else {
          this.getArr(item.children);
        }
      });
    }
  },
  watch: {
    currentLivestock: {
      handler: function () {
        if (this.applicationType == 13) this.requestZationNumber();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.leftnav {
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, #00404c 0%, #007d50 100%);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .navConLogo {
    height: 60px;
    width: 200px;
    img {
      height: 30px;
      width: 120px;
      background-size: cover;
      margin-top: 15px;
      margin-left: 24px;
    }
  }
  .navDiv {
    flex: 1;
    overflow-y: scroll;
  }
  .navDiv::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 0px;
    display: none;
  }
  ::-webkit-scrollbar-thumb .navDiv {
    /*滚动条里面小方块*/
    border-radius: 0px;
    background: #cfcbcb;
  }
  ::-webkit-scrollbar-track .navDiv {
    /*滚动条里面轨道*/
    border-radius: 0px;
    background: #ededed;
  }
  .el-menu {
    width: 200px;
    background: none;
    border-right: 0;
    overflow-y: scroll;
  }
  .el-menu::-webkit-scrollbar {
    display: none;
  }

  // 无子菜单的一级菜单
  .el-menu-item {
    border-bottom: none;
    height: 54px;
    line-height: 54px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    i {
      color: #ffffff;
    }
  }
  .el-menu-item:hover {
    background: rgba(0, 0, 0, 0.2);
  }
  // 有子菜单的一级菜单
  .el-submenu__title {
    border-bottom: none;
    height: 54px;
    line-height: 54px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    i {
      color: #ffffff;
    }
  }
  .el-submenu__title:hover {
    background: rgba(0, 0, 0, 0.2);
  }
  .el-menu-item.is-active {
    font-weight: 550;
    background: rgba(0, 0, 0, 0.5);
    color: #51f371;
    i {
      color: #51f371;
      font-weight: 550;
    }
  }
  // 屠宰场菜单
  .passageManage-icon {
    background-image: url('../../static/images/u78.png');
    background-size: cover;
    background-repeat: no-repeat;
  }
  .passageManage-icon-active {
    background-image: url('../../static/images/u78-2.png');
    background-size: cover;
    background-repeat: no-repeat;
  }

  .orderManage-icon {
    background-image: url('../../static/images/u257.png');
    background-size: cover;
    background-repeat: no-repeat;
  }
  .orderManage-icon-active {
    background-image: url('../../static/images/u257-2.png');
    background-size: cover;
    background-repeat: no-repeat;
  }

  /* 用户代理样式表 */
  li {
    text-align: -webkit-match-parent;
  }

  /* 侧边栏标题设置 */
  .title {
    margin-left: 12px;
    white-space: nowrap;
    height: 60px;
    line-height: 60px;
  }

  .title > span {
    font-size: 22px;
    font-weight: bold;
    margin-left: 15px;
    color: #fff;
  }

  .menu-info {
    background: #d9001b;
    font-size: 12px;
    color: #fff;
    border-radius: 10px;
    height: 20px;
    line-height: 20px;
    padding: 0 8px 0 8px;
    position: absolute;
    top: 5px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .el-submenu__icon-arrow {
    right: 15px;
    top: 32px;
  }
  .el-icon-arrow-down {
    right: 15px;
    top: 28px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/leftnav.vue